import MallGroupApi from '@/api/zfb/mall_group'
import { Service_GetPddMoveInfo ,Service_DeletePddMoveInfo,Service_SetPddMoveInfo} from '@/service/auth_mall_service'
import { message } from "ant-design-vue"


// 获取店铺列表
async function GetMallList(GroupId) {

  var  {mallList, success , msg} = await MallGroupApi.GetMallListByGroupId(1,100,GroupId)
  if (!success) message.warn(`获取授权店铺列表数据失败，原因:【${msg}】`)
  let list = mallList
  const localMallData = Service_GetPddMoveInfo()
  if (list?.length) {
    // 如果本地还没有存储晓风上货的店铺数据那么默认取第1个店铺
    if (!localMallData) Service_SetPddMoveInfo(list[0])
    // 如果本地有存过, 那要判断下是否需要重新存储一次
    else {
      const item = list.find(i => i.ShopId === localMallData.ShopId)
      if (!item) Service_SetPddMoveInfo(list[0])
      else if (item && item.Id !== localMallData.Id || item.auth?.AppExpiresIn !== localMallData.auth?.AppExpiresIn) Service_SetPddMoveInfo(item) 
    } 
  }
  else  Service_DeletePddMoveInfo()
  return list
}



export default {GetMallList}
